import React from 'react'
import Container from 'react-bootstrap/Container'
import { Outlet } from 'react-router-dom'
import MyNavbar from '../component/MyNavbar'

export default function LayoutPage() {
  return (
    <>
        <MyNavbar />
        <Container style={{marginTop : '3.5rem'}}></Container>
        <Outlet />
    </>
  )
}
